/* Encryption User based on base64 */
export const setCurrentUser = (user) => {
  const objStr = JSON.stringify(user)
  localStorage.setItem('current_user', objStr)
}

export const setToken = (token) => {
  localStorage.setItem('_auth', token)
}

export const setUrlPayment = (url_payment) => {
  localStorage.setItem('url_payment', token);
}

export const getUrlPayment = () => {
  return localStorage.getItem('url_payment');
}

export const getToken = () => {
  return localStorage.getItem('_auth')
}

export const setPhone = (phone) => {
  localStorage.setItem('customer_number', phone)
}

export const setDob = (dob) => {
  if (dob) localStorage.setItem('dob', dob)
}

export const getDob = () => {
  let dob = localStorage.getItem('dob')
  if (dob) return dob
  return ''
}

export const getPhone = () => {
  return localStorage.getItem('customer_number')
}

/* Decrypting User based on base64*/
export const getCurrentUser = () => {
  const data = localStorage.getItem('current_user')
  if (!data) {
    return null
  }
  return JSON.parse(data)
}

export const signOut = () => {
  //remove total token
  localStorage.setItem('_auth', '')
  localStorage.setItem('current_user', null)
}

export const isLoggedIn = () => {
  const data = getCurrentUser()
  return !!data
}




// WEBPACK FOOTER //
// ./src/services/authService.js